import styled from 'styled-components';

export const LevelZeroWrap = styled.div`
  width: 100%;
  display: fixed;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  position: relative;
  > div {
    width: calc(100% / 3);
  }
`;
